import type { FieldSchemaType } from '../stepsMap';

import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionPageContext } from '../QuestionPageProvider';
import { fieldSchema } from '../stepsMap';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import Container from '$/components/elements/Container';
import AutocompleteInputQuestion from '$/components/elements/Questions/AutocompleteInputQuestion';
import fieldOfStudyList from '$/components/elements/Questions/lists/fieldOfStudyList';
import * as queries from '$/graphql/queries';

const Field = () => {
  const { setCurrentStep, dispatch, state } = useContext(QuestionPageContext);

  const { control, handleSubmit } = useForm<FieldSchemaType>({
    mode: 'onChange',
    resolver: yupResolver(fieldSchema),
  });

  const onSubmit = (payload: FieldSchemaType) => {
    dispatch({
      type: 'set',
      payload,
    });
    setCurrentStep('city');
  };

  return (
    <StudentQuestion noLimitHeight>
      <Container as="form">
        <AutocompleteInputQuestion
          allowCustomAnswer={false}
          control={control}
          name={'field'}
          title={`In welchem Studienbereich liegt ${state.major?.[0].value}?`}
          subTitle={'Studienbereich suchen'}
          placeholder={'Suche den Studienbereich'}
          query={queries.subjectAutoComplete}
          list={fieldOfStudyList}
          maxElements={10}
          onValueSelected={handleSubmit(onSubmit)}
        />
      </Container>
    </StudentQuestion>
  );
};

export default Field;
